import useGeneralApi from "views/Settings/General/hooks/useGeneralApi";
import useGetCompanyData from "views/hooks/useGetCompanyData";
import { useParams } from "react-router-dom";
import { useEffect } from "react";

export const useSetupData = (current: number) => {
  const urlParams = useParams();
  const {
    mainAddress,
    listAddresses,
    listUnitMeasures,
    getCompanySetting,
    companySettingLoading,
    refetchGetCompanySetting: refetch,
  } = useGeneralApi();

  const { getCompany, loading } = useGetCompanyData();

  useEffect(() => {
    if (urlParams?.companyId) {
      getCompany({
        variables: {
          id: urlParams.companyId,
        },
      });
      getCompanySetting({
        variables: {
          id: urlParams.companyId,
        },
      });

      if (current === 3) {
        listUnitMeasures({
          variables: {
            filter: {},
          },
        });
      }

      if (current === 1) {
        listAddresses({
          variables: {
            filter: { company_In: urlParams.companyId, addressType: "main" },
            limit: 10,
            offset: 0,
          },
        });
      }
    }
  }, [urlParams.companyId, current]);

  return {
    companySettingLoading,
    mainAddress,
    refetch,
    loading,
  };
};
